var map = {
	"./about.md": "d9f8",
	"./config": "bd35",
	"./config.json": "bd35",
	"./links": "ff63",
	"./links.json": "ff63",
	"./posts": "91d6",
	"./posts.json": "91d6",
	"./project-des.md": "7b68",
	"./projects": "c8bb",
	"./projects.json": "c8bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d91";